export default function Development() {

    const devHost = 'malina';

    const host = window.location.port === '3000' ? devHost : window.location.hostname;
    const port = window.location.port === '3000' ? ':8000' : '';
    const ws = window.location.port === '3000' ? 'ws' : 'wss';

    return [ host, port, ws ];
}